export default __webpack_public_path__ + "static/media/CITIPAGES.b254b85d.png";